import WSProgressBar from "../../Workspace2/WSProgressBar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import FormGroup from "@mui/material/FormGroup";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Badge from "@mui/material/Badge";
import "./../..././../../../WorkSpace/SignUp2.css";
import "../../../WorkSpace/font.css";

import {
  CreateCompany,
  // CreateIr,
  // GetAllCompany,
  // GetAllCompanyData,
  GetCheckedIR,
  UpdateStepStatus,
  // fetchIR,
  // getCheckData,
  getCompany,
  getWorkspace,
  // getCompanyByPreparerId,
  GetAllImportedCompanies,
} from "../ApiServices/apiHandler";
import { useEffect } from "react";
import useFetchApi from "../../../services/CustomHook/useFetchApi";
import swal from "sweetalert";
import { useState } from "react";
// import { getCompanybyId } from "../../../Console/Component/services/apiHandler";
import { useHistory, useLocation } from "react-router";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
// import { addWeeks } from "date-fns";
import WorkspaceHeader from "./WorkspaceHeader";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addCompany, getOneBookClosure } from "../../../Bookclosure/Services/ApiHandler";
import { toast } from "react-toastify";
import { motion } from "framer-motion";

import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css"
import wsCreationcss from "../../../myfin_v2/css/workspaceCreation.module.css"
import { ReactComponent as RightIcon } from "../../../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as PervBtnIcon } from '../../../myfin_v2/assets/icons/pervECLBtnIcon.svg'
import { ReactComponent as SearchIcon } from '../../../myfin_v2/assets/icons/search.svg';
import { ReactComponent as CloseGreyIcon } from "../../../myfin_v2/assets/icons/close_grey.svg";
import { ReactComponent as CircleCheckIcon } from '../../../myfin_v2/assets/icons/circle_check2.svg'

const label = { inputProps: { "aria-label": "Checkbox demo" } };
const label2 = { inputProps: { "aria-label": "Checkbox demo" } };

const AddCompanies = (props) => {
  const dispatch = useDispatch()

  const { id } = useParams();
  let history = useHistory();

  const user = JSON.parse(localStorage.getItem('user'));


  const location = useLocation();
  let a = location.pathname;
  const { loading, response, error } = useFetchApi(
    `api/v1/company-data/all-IR`
  );

  const { bookClosureId } = useSelector((state) => state.BookClosureReducer);

  const [workspace, setWorkspace] = useState("");
  const [singleWorkspace, setSingleWorkspace] = useState({});
  const [investmentRegister, setInvestmentRegister] = useState([]);
  const [investmentRegisterImported, setInvestmentRegisterImported] = useState(false)
  const [isOpenIr, setIsOpenIr] = useState(false);

  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [companyImported, setCompanyImported] = useState(false)
  const [importedCompany, setImportedCompany] = useState([]);
  const [isOpenCompany, setIsOpenCompany] = useState(false);

  const [showIrSearch, setShowIrSearch] = useState(false);
  const [searchIrText, setSearchIrText] = useState("");
  const [irSearchExpanded, setIrSearchExpanded] = useState(false);

  const [showCompanySearch, setShowCompanySearch] = useState(false);
  const [searchCompanyText, setSearchCompanyText] = useState("");
  const [companySearchExpanded, setCompanySearchExpanded] = useState(false);
  const [importedCompanies, setImportedCompanies] = useState([])

  useEffect(() => {
    if (response && Object.keys(response).length > 0) {
      setInvestmentRegister(response.data.fetchIR)
    }
    if (error) {
      swal("Error", error, "error");
    }
    getIr();
    companyData();
    getWorkspaceDetails();
    GetAllImportedCompany();
  }, [response || error]);

  // useEffect(() => {
  //   if(!bookClosureId){
  //     getOneBookClosure(id).then(response => {
  //       dispatch({ type: "BOOK_cLOSURE_DATA", payload: response.data.bookClosure || {} });
  //     }).catch(error => {
  //       swal("Error", `Book Closure Error: ${error.response?.data?.error}`, 'error');
  //     })
  //   }
  // }, [bookClosureId])

  const handleOpenIr = () => {
    setIsOpenIr(!isOpenIr);
  }
  const handleOpenCompany = () => {
    setIsOpenCompany(!isOpenCompany);
  }
  const GetAllImportedCompany = async () => {
    const user_id = user._id;
    const res = await GetAllImportedCompanies(user_id);
    if (res.status === 200) {
      setImportedCompany(res.data.result);
    }
  };

  const companyData = async () => {
    try {
      const res = await getCompany();
      if (res.status === 200) {
        setCompany(res.data.getCompany)
      }
    } catch (error) {
      console.log(error.message, "error");
    }
  };
  const getWorkspaceDetails = async () => {
    const res = await getWorkspace(id);
    if (res.status === 200) {
      setSingleWorkspace(res.data?.getworkspace[0])
      const workspaceData = res.data?.getworkspace[0];
      if (workspaceData && workspaceData.book_closure_as_on_date) {
        getOneBookClosure(id).then(response => {
          dispatch({ type: "BOOK_cLOSURE_DATA", payload: response.data.bookClosure || {} });
        }).catch(error => {
          swal("Error", `Book Closure Error: ${error.response?.data?.error}`, 'error');
        })
      }
    }
  }

  const getIr = async () => {
    try {
      const res = await GetCheckedIR(id);
      if (res.status === 200) {
        console.log(res, '---------')
        if (res.data.getIR[0].all_IR_checked.length > 0) {
          setInvestmentRegisterImported(true)
          setSelectedInvestmentRegister(res.data.getIR[0].all_IR_checked)
        } else {
          setInvestmentRegisterImported(false)
        }

        setImportedCompanies(res.data.getIR[0]?.all_company_checked || [])
        if (res.data.getIR[0].all_company_checked.length > 0) {
          setCompanyImported(true)
          setSelectedCompany(res.data.getIR[0].all_company_checked)
          setImportedCompanies(res.data.getIR[0]?.all_company_checked || [])

        } else {
          setCompanyImported(false)
        }

        setWorkspace(res.data.getIR[0]);
      }
    } catch (error) { }
  };



  const nextPage = async () => {
    try {
      const data = {
        steps: "step3",
        has_published: "draft",
        status: singleWorkspace.status,
        approver_id: singleWorkspace.approver_id,
        cancel_reason: singleWorkspace.cancel_reason,
      };

      const res = await UpdateStepStatus(id, data);
      if (res.status === 200) {
        history.push(`/importregister/${id}`);
      }
    } catch (error) {
      console.log("error", error.message);
      return 0;
    }
  };


  const companyName = (c_id) => {
    try {
      //console.log(c_id, "ciiii");
      const nameCompany = company.filter((adj) => adj._id === c_id);
      const result = nameCompany[0]?.company_name
        ? nameCompany[0]?.company_name
        : "unknown";
      return result;
    } catch (error) {
      console.log(error, "2222");
      return 0;
    }
  };

  const updateCheckedIR = (key, checked_data) => {
    const data = {
      w_id: id,
      [key]: checked_data
    }
    CreateCompany(data).then(res => {
      if (key === "all_company_checked" && singleWorkspace && singleWorkspace.book_closure_as_on_date) {
        setImportedCompanies(checked_data)

        // ? Update company in Book Closure Array
        addCompany(bookClosureId, { companies: checked_data }).then(response => {
          toast.success("Company Added Successfully.")
        }).catch(error => {
          swal("Error", `Error: ${error.response?.data?.error}`, 'error');
        })

      }
      getIr();
      return res
    }).catch(err => {
      swal("Error", err, "error");
      return err
    })
  }

  // const handleSelectIR = (event, id) => {
  //   setSelectedInvestmentRegister((prevItems) => {
  //     // If the value is checked, push it to the array; otherwise, remove it
  //     if (prevItems.includes(id)) {
  //       updateCheckedIR("all_IR_checked", selectedInvestmentRegister.filter((item) => item !== id));
  //       return prevItems.filter((item) => item !== id);
  //     } else {
  //       setInvestmentRegisterImported(false)
  //       return [...prevItems, id];
  //     }
  //   })
  // };

  const handleSelectIR = (event, id) => {
    setSelectedInvestmentRegister((prevItems) => {
      if (prevItems.includes(id)) {
        const updated = prevItems.filter((item) => item !== id);
        updateCheckedIR("all_IR_checked", updated);
        return updated;
      } else {
        setInvestmentRegisterImported(false);
        const updated = [...prevItems, id];
        return updated;
      }
    });
  };
  const importAllIR = async () => {
    const allIRIds = investmentRegister.map((ir) => ir._id)
    setSelectedInvestmentRegister(allIRIds);
    updateCheckedIR("all_IR_checked", allIRIds);
  }

  // const handleSelectCompany = (event, id) => {
  //   setSelectedCompany((prevItems) => {
  //     // If the value is checked, push it to the array; otherwise, remove it
  //     if (prevItems.includes(id)) {
  //       updateCheckedIR("all_company_checked", selectedCompany.filter((item) => item !== id));
  //       return prevItems.filter((item) => item !== id);
  //     } else {
  //       setCompanyImported(false)
  //       return [...prevItems, id];
  //     }
  //   })
  // };
  const handleSelectCompany = (event, id) => {
  setSelectedCompany((prevItems) => {
    if (prevItems.includes(id)) {
      return prevItems.filter((item) => item !== id);
    } else {
      setCompanyImported(false); // if you still need this
      return [...prevItems, id];
    }
  });
};

  const importAllCompany = async () => {
    const allCompanyIds = company.map((ir) => ir._id)
    if (user.responsibilities === "preparer") {
      const matchingCompanyIds = allCompanyIds.filter(id => importedCompany.includes(id));
      setSelectedCompany(matchingCompanyIds)
      updateCheckedIR("all_company_checked", matchingCompanyIds);
    } else {
      setSelectedCompany(allCompanyIds)
      updateCheckedIR("all_company_checked", allCompanyIds);
    }
  }

  const [selectedInvestmentRegister, setSelectedInvestmentRegister] = useState([]);


  const allChecked =
    investmentRegister.length > 0 &&
    investmentRegister.every((ir) =>
      selectedInvestmentRegister.includes(ir._id)
    );

  // Toggle an individual item
  const handleItemToggle = (item) => {
    setSelectedInvestmentRegister((prev) =>
      prev.includes(item)
        ? prev.filter((i) => i !== item) // remove
        : [...prev, item] // add
    );
  };

  // Toggle *all* items
  const handleToggleAll = () => {
    const allIds = investmentRegister.map((ir) => ir._id);
    setSelectedInvestmentRegister(allChecked ? [] : allIds);
  };

  const openSearch = (type) => {
    if(type === "IR"){
      setShowIrSearch(true);
    }else if (type=== "company"){
      setShowCompanySearch(true)
    }
	};

	const closeSearch = (type) => {
    if(type === "IR"){
      setIrSearchExpanded(false);
      setTimeout(() => setShowIrSearch(false), 600);
      setSearchIrText("");
    }else if (type === "company"){
      setCompanySearchExpanded(false);
      setTimeout(() => setShowCompanySearch(false), 600);
      setSearchCompanyText("");
    }
		
	};

  useEffect(() => {
    if (showIrSearch) {
      const timeout = setTimeout(() => setIrSearchExpanded(true), 15);
      return () => clearTimeout(timeout);
    } else {
      setIrSearchExpanded(false);
    }
  }, [showIrSearch]);

  useEffect(() => {
    if (showCompanySearch) {
      const timeout = setTimeout(() => setCompanySearchExpanded(true), 15);
      return () => clearTimeout(timeout);
    } else {
      setCompanySearchExpanded(false);
    }
  }, [showCompanySearch]);

  console.log("importedCompanies",importedCompanies);
  console.log("importedCompanies-length",importedCompanies.length);
  

  return (
    <>
      <div className={`ml-0 mr-0 ${commoncss.dFlexClm}`}>
        <div >
          <WSProgressBar activePage={3} id={id} />
        </div>
        <div className={wsCreationcss.wsContentDiv}>
          <span className={wsCreationcss.wsContentHeading}>
            Which companies should we add in your workspace?
          </span>
          <motion.div
            initial={{ x: 500, y: 500, opacity: 0 }}
            animate={{ x: 0, y: 0, opacity: 1 }}
            exit={{ x: 0, y: 0, opacity: 0 }}
            transition={{ duration: 0.7, ease: "easeInOut" }} className={`${commoncss.dFlex}`} style={{ "gap": "20px", "margin-top": "38px" }}>
            <div
              className={`${wsCreationcss.crtCompanyCard}`}>
              <div className={commoncss.dFlexJustifysb}>
                <span className={commoncss.dFlex}>
                  <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleToggleAll}
                    style={{ "margin": "0px 10px", "width": "14px" }}
                    disabled={user.responsibilities === "approver" || singleWorkspace.status === "waiting" || user.responsibilities === "view"}
                  />
                  <span className={wsCreationcss.moduleLabel}>Investment Registers</span>
                </span>
                {!showIrSearch && (
                  <SearchIcon onClick={()=>{openSearch("IR")}} style={{cursor:"pointer"}} />
                )}

                {showIrSearch && (
                  
                  <div className={`${wsCreationcss.searchBox} ${irSearchExpanded ? wsCreationcss.expanded : ""}`}>
                    <SearchIcon className={wsCreationcss.searchInside}/>
                    <input
                      type="text"
                      value={searchIrText}
                      onChange={(e) => setSearchIrText(e.target.value)}
                      placeholder="Search..."
                      className={wsCreationcss.searchInput}
                    />
                    <CloseGreyIcon
                      style={{cursor:"pointer"}}
                      onClick={()=>{closeSearch("IR")}}
                    />
                  </div>
                )}
              </div>
              <hr style={{ "margin": "1rem -15px" }} />
              <div className={wsCreationcss.scrollArea}>
                {investmentRegister.length > 0 &&
                  investmentRegister
                  .filter((ir) =>
                    ir?.ir_name?.toLowerCase().includes(searchIrText.toLowerCase())
                  )
                  .map((ir) => {
                    return (
                      <>
                        {ir?.ir_name &&
                          <>
                            <div className="d-flex " style={{ "height": "27px" }}>
                              <input
                                type="checkbox"
                                checked={selectedInvestmentRegister.includes(ir._id)}
                                disabled={user.responsibilities === "approver" || singleWorkspace.status === "waiting" || user.responsibilities === "view"}
                                id={ir._id}
                                onChange={(event) => {
                                  handleSelectIR(
                                    event,
                                    ir._id
                                  );
                                }

                                }
                              />
                              <span className="d-flex justify-content-between align-items-center w-100 font-sans">
                                <span className={wsCreationcss.addCompanyLabel}>
                                  {ir?.ir_name ? ir?.ir_name : "unknown"}
                                </span>
                                <strong className={wsCreationcss.addCompanyLabel} style={{ paddingRight: "1rem", color: "#33584E", textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "12px" }}>
                                  {companyName(ir.parent_company_id)}
                                </strong>
                              </span>
                            </div>
                          </>
                        }
                      </>
                    );
                  })}
              </div>
              <hr />
              <div className={commoncss.dFlexJustifysb}>
                <div></div>
                <button className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}
                  onClick={() => updateCheckedIR("all_IR_checked", selectedInvestmentRegister)}
                  disabled={user.responsibilities === "approver" || singleWorkspace.status === "waiting" || user.responsibilities === "view"}
                >Import selected</button>
              </div>
            </div>
            <div
              className={`${wsCreationcss.crtCompanyCard}`}>
              <div className={commoncss.dFlexJustifysb}>
                <span className={wsCreationcss.moduleLabel}>Company List 
                  {importedCompanies.length > 0 && (
                    <CircleCheckIcon style={{ marginLeft:"5px" }} className="mr-2 mb-1" />
                  )}
                </span>

                {!showCompanySearch && (
                  <SearchIcon onClick={()=>{openSearch("company")}} style={{cursor:"pointer"}} />
                )}

                {showCompanySearch && (
                  
                  <div className={`${wsCreationcss.searchBox} ${companySearchExpanded ? wsCreationcss.expanded : ""}`}>
                    <SearchIcon className={wsCreationcss.searchInside}/>
                    <input
                      type="text"
                      value={searchCompanyText}
                      onChange={(e) => setSearchCompanyText(e.target.value)}
                      placeholder="Search..."
                      className={wsCreationcss.searchInput}
                    />
                    <CloseGreyIcon
                      style={{cursor:"pointer"}}
                      onClick={()=>{closeSearch("company")}}
                    />
                  </div>
                )}
                
              </div>
              <hr style={{ "margin": "1rem -15px" }} />
              <div className={wsCreationcss.scrollArea}>

                {company.length > 0 && 
                  company.filter((comp) =>
                    comp?.company_name?.toLowerCase().includes(searchCompanyText.toLowerCase())
                  )
                  .map((comp) => {
                  return (
                    <>
                      <div className="d-flex" style={{ "height": "27px" }}>
                        <input
                          type="checkbox"
                          checked={selectedCompany.includes(comp._id)}
                          disabled={user.responsibilities === "approver" || user.responsibilities === "preparer" && !importedCompany.includes(comp._id) || singleWorkspace.status === "waiting" || user.responsibilities === "view"}
                          id={comp._id}
                          onChange={(event) =>
                            handleSelectCompany(
                              event,
                              comp._id
                            )
                          }
                        />
                        <span className="d-flex justify-content-between align-items-center w-100 font-sans">
                          <span className={wsCreationcss.addCompanyLabel}>
                            {comp?.company_name}
                          </span>
                        </span>
                      </div>

                    </>
                  );
                })}
              </div>
              <hr />
              <div className={commoncss.dFlexJustifysb}>
                <div></div>
                <button className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}
                  disabled={user.responsibilities === "approver" || singleWorkspace.status === "waiting" || user.responsibilities === "view"}
                  onClick={() => updateCheckedIR("all_company_checked", selectedCompany)}
                >Import selected</button>
              </div>
            </div>
          </motion.div>
        </div>
        <div className={wsCreationcss.footerContainer}>
          <div>
            <button
              onClick={() => {
                dispatch({ type: "WS_BACK_FROM_QUERY", payload: "addCompanies" });
                history.push(`/dashboard`)
              }}
              className={wsCreationcss.cancelBtn} type="button" style={{ "padding": "7px" }}>Cancel</button>
          </div>
          <div className={wsCreationcss.footerbtnContainer}>
            <button
              className={wsCreationcss.perviewBtn} onClick={() => {
                dispatch({ type: "WS_BACK_FROM_QUERY", payload: "addCompanies" });
                history.push(`/workspacesetup/${id}`)
              }} type="button" style={{ "padding": "7px" }}><PervBtnIcon height={19} />Previous</button>

            {workspace?.all_company_checked?.length > 0 ||
              workspace?.all_IR_checked?.length > 0 ? (
              <button onClick={nextPage} className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}>Next<RightIcon height={12} /></button>
            ) : (
              <button className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}>Next<RightIcon height={12} /></button>

            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default AddCompanies;
